import { createBrowserRouter } from "react-router-dom";
import { AppLayout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Home } from "@/pages/Home";
import { Login } from "@/pages/Login";
import { Callback } from "@/pages/Callback";
import { Dashboard } from "@/pages/Dashboard";
import { Projects } from "@/pages/Projects";
import { Properties } from "@/pages/Properties";
import { Flags } from "@/pages/Flags";
import { Account } from "@/pages/Account";
import { PreviewPage } from "@/pages/PreviewPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "login", element: <Login /> },
      { path: "callback", element: <Callback /> },
      { path: "preview", element: <PreviewPage /> },
      {
        path: "dashboard",
        element: (
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "projects",
        element: (
          <ProtectedRoute>
            <Projects />
          </ProtectedRoute>
        ),
      },
      {
        path: "properties",
        element: (
          <ProtectedRoute>
            <Properties />
          </ProtectedRoute>
        ),
      },
      {
        path: "flags",
        element: (
          <ProtectedRoute>
            <Flags />
          </ProtectedRoute>
        ),
      },
      {
        path: "account",
        element: (
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);
